import { render, staticRenderFns } from "./TicimaxOrderDetail.vue?vue&type=template&id=046cd9f8"
import script from "./TicimaxOrderDetail.vue?vue&type=script&lang=js"
export * from "./TicimaxOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports